import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import './assets/css/global.css'
import './axios/axios.config.js'
import './router/router.js'
import './assets/font/iconfont.css'
import './utils/validate'
import  directive from './directive/index'

import {download, showPublicLoading} from '@/utils/download'
import jquery from "jquery";

Vue.prototype.$ = jquery;
Vue.prototype.$showPublicLoading = showPublicLoading
Vue.prototype.$download = download
import './assets/icon/iconfont.css'
import './assets/icon/iconfont.js'

//全局配置ant-design-vue
//安装下载npm install ant-design-vue --save
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';


Vue.use(Antd);
Vue.use(directive)
Vue.config.productionTip = false
Vue.prototype.$http = axios
// Vue.directive('showimg', showimgDirectiive)
Vue.config.errorHandler = function (err, vm, info) {
  console.error(err);
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
